import React, { Component } from 'react'
import { Button, Form, Checkbox, Table, Select, Input } from 'semantic-ui-react';
// import MaterialTable from 'material-table'
// import Icon from '@material-ui/core/Icon'
import { Modal, ModalHeader, ModalBody, ModalFooter, Table as Table2 } from 'reactstrap';
import { IconButton } from '@material-ui/core';
import Menu from '@material-ui/icons/Menu';
// import Parse from 'widget/parse'
import localization from 'widget/MaterialTableOpt'

export default class ModalNamelist extends Component {
  state = {
    open: false,
    suirChecked: false,
    checkedValue: this.props.rowData.employeeArr || [],
    proportionArr: [],
    radioValue: '',
    proportionSel: {},
  }

  // componentDidMount = async () => {
  //   const { rowData } = this.props
  //   console.log(rowData)
  //   let sel = {}
  //   rowData.jointObjArr.forEach(item => {
  //     sel = {
  //       ...sel,
  //       [item.objectId]: item.proportion
  //     }
  //   })
  //   this.setState({ proportionSel: sel })
  // }
  open = () => this.setState({ open: true })
  close = () => this.setState({ open: false })

  toggle = () => {
    const { people1 } = this.props
    const { suirChecked } = this.state;

    let checkedValue = [];

    if (!suirChecked) {
      people1.forEach(({ objectId }) => { checkedValue.push(objectId); });
    } else {
      checkedValue = [];
    }
    this.setState({ checkedValue, suirChecked: !suirChecked });
  }

  handleClick = (e, item) => {
    // console.log('Click', e.target.checked, item)

    const { checkedValue } = this.state;
    const { value, checked } = item;

    const indexof = checkedValue.indexOf(value);
    if (checkedValue.indexOf(value) === -1) {
      checkedValue.push(value);
    } else {
      checkedValue.splice(indexof, 1)
    }
    this.setState({ checkedValue });
  }

  handleRadioChange = (e, { value }) => this.setState({ radioValue: value })

  handleSubmit1 = async () => {
    const { employee, rowData, onRowDataChange } = this.props;
    const { radioValue, checkedValue, proportionSel } = this.state;
    const jointObjArr = []
    const arr = checkedValue
    arr.forEach(item => {
      const obj = employee.find(item2 => item2.objectId === item);
      if (obj) {
        const { objectId, jobNum, name, username } = obj
        const proportion = proportionSel[objectId];
        jointObjArr.push({ objectId, jobNum, name, username })
      }
    })

    onRowDataChange({ ...rowData, jointObjArr, employeeArr: checkedValue });
    this.close();
  }



  render() {
    const { employee } = this.props
    const { open, suirChecked, checkedValue, radioValue, proportionSel } = this.state
    console.log(checkedValue)
    return (<>
      <IconButton onClick={this.open}><Menu fontSize='small' /></IconButton>
      <Modal
        isOpen={open}
        size='lg'
        toggle={this.close}
      >
        <ModalHeader className="justify-content-center">
          <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggle}>
            <span aria-hidden="true">×</span>
          </button>
          代入員工資料
        </ModalHeader>
        <ModalBody>
          <Table striped size='small'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>
                  <Checkbox
                    label='全選'
                    onClick={this.toggle}
                  />
                </Table.HeaderCell>
                <Table.HeaderCell>姓名</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {employee.map(({ objectId, jobNum, name, username, proportion, addr }) => (
                <Table.Row key={'p1' + objectId}>
                  <Table.Cell>
                    <Checkbox
                      label=''
                      value={objectId}
                      checked={checkedValue.indexOf(objectId) !== -1}
                      disabled={suirChecked}
                      onClick={this.handleClick}
                    />
                  </Table.Cell>
                  <Table.Cell>{jobNum} {name || username}</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </ModalBody>
        <ModalFooter style={{ padding: '16px' }}>
          <Button icon='tag' primary content='代入' onClick={this.handleSubmit1} />
          <Button icon='x' content='關閉' onClick={this.close} />
        </ModalFooter>
      </Modal>
    </>)
  }
}
